var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { staticClass: "nav" }, [
    _c("div", [
      _c(
        "span",
        { staticClass: "brand" },
        [
          _c("router-link", { attrs: { to: _vm.home_url } }, [
            _c("img", { attrs: { src: _vm.peasylogo, alt: "peasy-logo" } })
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", [
      _c("ul", { staticClass: "items" }, [
        _vm.accountId
          ? _c(
              "li",
              {
                staticClass: " font_regular font_500 text_14",
                staticStyle: { display: "flex" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.navigateBasedOnCartStatus($event)
                  }
                }
              },
              [
                _c("div", { staticClass: "shopcart" }, [
                  _c("span", { staticClass: "cart_count" }, [
                    _vm._v(_vm._s(_vm.currentCart.order_items.length))
                  ]),
                  _vm._v(" "),
                  _c(
                    "svg",
                    {
                      staticStyle: { "enable-background": "new 0 0 128 128" },
                      attrs: {
                        version: "1.1",
                        id: "shopping_x5F_carts_1_",
                        xmlns: "http://www.w3.org/2000/svg",
                        x: "0",
                        y: "0",
                        viewBox: "0 0 128 128",
                        "xml:space": "preserve"
                      }
                    },
                    [
                      _c("g", { attrs: { id: "x341" } }, [
                        _c("path", {
                          staticClass: "st2",
                          attrs: {
                            d:
                              "M45.3 81.2h78V43.7L35.9 25.4l-3.1-12.9-12.6-4.2c0-.2.1-.3.1-.5 0-4.3-3.5-7.8-7.8-7.8S4.7 3.5 4.7 7.8s3.5 7.8 7.8 7.8c1.8 0 3.4-.6 4.7-1.6l9.4 4.7L39 78l-12.5 9.4V103l5.7 7.1c-1.6 1.9-2.5 4.3-2.5 7 0 6 4.9 10.9 10.9 10.9s10.9-4.9 10.9-10.9-4.9-10.9-10.9-10.9c-.9 0-1.8.1-2.6.3l-2.1-3.4h65.6l3.6 6c-2.2 2-3.6 4.9-3.6 8.1 0 6 4.9 10.9 10.9 10.9s10.9-4.9 10.9-10.9-4.9-10.9-10.9-10.9h-.3l-1.3-3.1h12.5V97H32.8v-6.2l12.5-9.6zm0-6.3-4.6-21.4.6 3L59.8 58l3.8 17H45.3zm21.8 0-3.7-16.7 18.1 1.4 1.4 15.3H67.1zm18.8 0-1.4-15 17 1.3v13.7H85.9zm31.2-15.6v15.6h-12.5V61.5l12.5 1v-3.2l-12.5-1V44.4l12.5 2.4v12.5zM35.9 31.2l65.6 12.6V58l-17.3-1.4-1.5-16.4-3.1-.6 1.6 16.8-18.5-1.5-4.3-19.3-3.7-.7 4.4 19.7-18.5-1.5-4.7-21.9zm76.5 81.2c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.7 4.7-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7zm-71.8 0c2.6 0 4.7 2.1 4.7 4.7s-2.1 4.7-4.7 4.7-4.7-2.1-4.7-4.7 2.1-4.7 4.7-4.7z",
                            id: "icon_11_"
                          }
                        })
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "font_600 uppercase" }, [
                  _vm._v(
                    _vm._s(_vm.merchant.currency) +
                      _vm._s(_vm.currentCart.summary.grantTotal)
                  )
                ])
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }